// Lightweight loader for auth guards. Replaces a MUI CircularProgress so the
// guard files can stay eager-imported in App.jsx without dragging the entire
// MUI bundle (~407 KB) into the initial landing-page chunk.
function AuthLoader() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <span className="auth-loader-spinner" aria-label="Loading" />
    </div>
  );
}

export default AuthLoader;
